import React, { useEffect, useState } from "react";
import { Space } from "antd";
import axios from "axios";
import { Error, Success } from "../../Messages/Messages";
import moment from "moment";
import { CreateNewMilestone } from "./CreateMilestones";
import { UpdateMilestone } from "./UpdateMilestone";
import MilestoneDetails from "./MilestoneDetails";
import DeleteModal from "../../DeleteModal/DeleteModal";
import DropdownComp from "../../Dropdowns/DropdownComp";
import GeneralTable from "../../GeneralTable";
import { generalErrorAlert } from "../../GeneralErrorAlert";
import Tagcomp from "../../TagComp/Tagcomp";
import SearchBarComp from "../../SearchBar/SearchBar";
import PageToolbar from "../../../design-system/PageToolbar";

import { useTranslation } from "react-i18next";
const ProjectMilestones = ({ project, onClickDetailsView }) => {
  const { t } = useTranslation("dashboard");
  const [milestones, setMilestones] = useState([]);
  const [employeesArray, setEmployeesArray] = useState([]);
  const [milestoneDetails, setMilestoneDetails] = useState({});
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(6);
  const [inventoryList, setInventoryList] = useState([]);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  useEffect(() => {
    let makeOptions = project?.team?.map(d => ({
      label: d?.firstName + " " + d?.lastName,
      value: d?._id
    }));
    setEmployeesArray(makeOptions);
  }, [project?._id]);

  useEffect(() => {
    getData();
    getInventory();
    return () => {};
  }, [project?._id, searchText, pageNo]);

  const getInventory = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/inventory/filters`,
        { pageSize: 1000000, pageNo: 0 },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      if (res.status === 200 || res.status === 304) {
        setInventoryList(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching inventory:", err);
    }
  };

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/milestones/filters`,
        { projectId: project?._id, searchText, pageSize, pageNo: pageNo - 1 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setMilestones(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/milestones/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      mobile: "title",
      render: (text, record) => record.name,
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: t("Start Date"),
      dataIndex: "startDate",
      render: (text, record) => moment(text).format("DD/MMM/YYYY")
    },
    {
      title: t("Team"),
      dataIndex: "team",
      render: (text, record) => (
        <Space size={[4, 4]} wrap>
          {record?.team?.map((user, index) => (
            <Tagcomp key={user?._id || index} text={`${user?.firstName} ${user?.lastName}`} />
          ))}
        </Space>
      )
    },
    {
      title: t("Status"),
      dataIndex: "status",
      mobile: "subtitle",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: text => <Tagcomp text={text} />
    },
    {
      title: t("Action"),
      key: "action",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "view",
            milestone: true
          },
          {
            key: "edit",
            component: () => (
              <UpdateMilestone
                inventoryList={inventoryList}
                milestone={obj}
                updateParent={getData}
                employeesArray={employeesArray}
              />
            )
          },
          {
            key: "delete",
            component: () => (
              <DeleteModal text="Milestone" onClick={() => deleteHandler(obj?._id)} />
            )
          }
        ];
        return (
          <div>
            <DropdownComp
              menuItems={menuItems}
              onSelectObject={() => {
                setMilestoneDetails(obj);
                onClickDetailsView(true);
              }}
            />
          </div>
        );
      }
    }
  ];

  return milestoneDetails?._id ? (
    <MilestoneDetails
      milestone={milestoneDetails}
      updateParent={getData}
      employeesArray={employeesArray}
      goBack={() => {
        setMilestoneDetails({});
        onClickDetailsView(false);
      }}
    />
  ) : (
    <div>
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={
          <CreateNewMilestone
            inventoryList={inventoryList}
            projectId={project?._id}
            updateParent={getData}
            employeesArray={employeesArray}
          />
        }
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={milestones}
        columns={columns}
        setPageNo={setPageNo}
      />
    </div>
  );
};

export default ProjectMilestones;
